var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 1.66797C8.35118 1.66797 6.74001 2.15671 5.3696 3.07239C3.99919 3.98807 2.93109 5.28956 2.30036 6.81227C1.66963 8.33499 1.5046 10.0105 1.82614 11.6271C2.14769 13.2436 2.94136 14.7284 4.1068 15.8939C5.27223 17.0593 6.75709 17.853 8.3736 18.1745C9.99011 18.4961 11.6657 18.331 13.1884 17.7003C14.7111 17.0696 16.0126 16.0015 16.9283 14.6311C17.8439 13.2606 18.3327 11.6495 18.3327 10.0013C18.3327 8.90695 18.1171 7.82332 17.6984 6.81227C17.2796 5.80123 16.6657 4.88257 15.8919 4.10875C15.1181 3.33492 14.1994 2.7211 13.1884 2.30231C12.1773 1.88352 11.0937 1.66797 9.99935 1.66797ZM9.99935 16.668C8.68081 16.668 7.39188 16.277 6.29555 15.5444C5.19922 14.8119 4.34474 13.7707 3.84016 12.5525C3.33557 11.3344 3.20355 9.99391 3.46078 8.7007C3.71802 7.40749 4.35296 6.21961 5.28531 5.28726C6.21766 4.35491 7.40554 3.71997 8.69875 3.46273C9.99196 3.2055 11.3324 3.33752 12.5506 3.84211C13.7688 4.34669 14.8099 5.20117 15.5425 6.2975C16.275 7.39383 16.666 8.68276 16.666 10.0013C16.666 11.7694 15.9636 13.4651 14.7134 14.7153C13.4632 15.9656 11.7675 16.668 9.99935 16.668Z",
    fill: "#2B9558"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLost);
export default __webpack_public_path__ + "static/media/lost.115c5bfc7e277cb8a110d2a8f16df2a3.svg";
export { ForwardRef as ReactComponent };